import api from "@/services/api";
import { PremiumDashboardType } from "@/types/premium/PremiumDashboard";

class GetPremiumDashboard {
  execute = async (franchiseId: string) => {
    const response = await api().get("/associate-premium/dashboard", {
      params: { franchiseId },
    });
    return response.data as PremiumDashboardType;
  };
}

export { GetPremiumDashboard };
